<template>
    <section class="betanoMag">
        <WidgetOne class="ad"/>
        <LatestMag/>
        <LastMags :offset="1"/>
    </section>
</template>

<script>
    import WidgetOne from '../components/WidgetOne.vue'
    import LatestMag from '../components/BetanoMag/LatestMag.vue'
    import LastMags from '../components/BetanoMag/LastMags.vue'

    export default {
        name: 'BetanoMagLayout',
        emits: ['ready'],
        components: {
            LatestMag,
            LastMags,
            WidgetOne,
        },
        props: {
        },
        data() {
            return {
            }
        },
        computed: {
            posts() {
                return this.$store.getters['betanomag/all']
            },
        },
        watch: {
            posts: {
                immediate: true,
                handler() {
                    console.log(this.posts.length)
                    if(this.posts.length == 0) return
                    this.$emit('ready')
                },
            },
        },
        mounted() {
            this.$store.dispatch("betanomag/getAll")
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.betanoMag {
    --side-padding: 5vw;
    padding: var(--menu-height) var(--side-padding) 0;

    .ad {
        margin-bottom: 2rem;
    }
}
</style>
